import { useEffect, useState } from "react";
import { Search } from "lucide-react";

import { NotificationsBell } from "@/components/notifications/NotificationsBell";
import { ThemeToggle } from "@/components/layout/ThemeToggle";

import { UserMenu } from "./UserMenu";

export function Header(): JSX.Element {
  // Detect macOS для отображения ⌘ vs Ctrl. Только cosmetic.
  const [isMac, setIsMac] = useState(false);
  useEffect(() => {
    setIsMac(/Mac|iPhone|iPad/.test(navigator.platform));
  }, []);

  const triggerCmdK = () => {
    window.dispatchEvent(
      new KeyboardEvent("keydown", { key: "k", metaKey: true }),
    );
  };

  return (
    <header className="h-16 border-b bg-background flex items-center justify-between px-6 sticky top-0 z-10">
      <div className="flex-1 max-w-md">
        <button
          type="button"
          onClick={triggerCmdK}
          className="flex h-9 w-full items-center gap-2 rounded-md border border-input bg-background px-3 text-sm text-muted-foreground transition-colors hover:border-primary hover:text-foreground"
        >
          <Search className="w-4 h-4" />
          <span className="flex-1 text-left">Поиск (страницы, товары…)</span>
          <kbd className="hidden rounded border bg-muted px-1.5 py-0.5 text-[10px] font-mono sm:inline">
            {isMac ? "⌘K" : "Ctrl+K"}
          </kbd>
        </button>
      </div>

      <div className="flex items-center gap-2">
        <ThemeToggle />
        <NotificationsBell />
        <UserMenu />
      </div>
    </header>
  );
}
